import React from 'react'

const ErrorPage = () => {
    return (
        <div className='w-screen h-screen bg-slate-800 flex justify-center items-center'><img src={require("../../assets/imagens/logo_lazy.png")} className="h-72 me-3" alt="Effect Logo" /></div>
    )
}

export default ErrorPage